'use client';

import React from 'react';
import { ProgressBar } from './ProgressBar';
import { useFormProgress } from './FormProgressContext';

interface ProgressBarWrapperProps {
  initialHeadline?: string;
}

export const ProgressBarWrapper = ({ initialHeadline }: ProgressBarWrapperProps) => {
  const { currentStep, totalSteps, percentage, headline, showBack, onBack } = useFormProgress();
  const effectiveHeadline = headline || initialHeadline || '';
  
  // Show headline on first step, progress bar on subsequent steps
  const isFirstStep = currentStep === 1 && percentage === 0;
  
  return (
    <div className="relative top-[85px] md:top-[110px] left-0 right-0 z-[90] bg-transparent mb-5 md:mb-3" aria-live="polite">
      <div className="relative w-[78%] md:max-w-[800px] mx-auto px-2 md:px-8">
        {/* Headline - positioned absolutely, visible only on first step */}
        {/* COMMENTED OUT - may want to restore in the future */}
        {/* <div className={`absolute inset-0 transition-opacity duration-500 ${isFirstStep ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
          <div>
            <h1 className="main-headline">
              <span className="headline-text">
                {effectiveHeadline}
              </span>
            </h1>
          </div>
        </div> */}
        
        {/* Progress bar with back button - positioned absolutely, smooth fade-in on second step */}
        <div className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${isFirstStep ? 'opacity-0' : 'opacity-100'}`}>
          <div className="flex items-center gap-6 md:gap-4">
            {/* Back button */}
            {showBack && onBack && (
              <button
                onClick={onBack}
                className="back-button flex-shrink-0 flex items-center gap-1 text-sm md:text-base font-semibold"
                tabIndex={0}
                aria-label="Go back"
              >
                <svg width="10" height="14" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-[4px] md:w-[13px] md:h-[18px] md:mr-[10px]">
                  <path d="M11.2 1L2 12.5L11.2 24" stroke="#070A29" strokeWidth="3"/>
                </svg>
                <span className="text-[15px] md:text-base font-semibold">Back</span>
              </button>
            )}
            
            {/* Progress bar */}
            <div className="flex-1">
              <ProgressBar 
                currentStep={currentStep} 
                totalSteps={totalSteps} 
                percentage={percentage} 
              />
            </div>
          </div>
        </div>
        
        {/* Invisible spacer to lock layout to 2-line eyebrow height on mobile */}
        {/* COMMENTED OUT - corresponds to headline above */}
        {/* <div className="invisible">
          <h1 className="main-headline">
            <span className="headline-text">
              {effectiveHeadline}
            </span>
          </h1>
        </div> */}
      </div>
    </div>
  );
};

